var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bills"},[_c('BillList',{ref:"BillList",attrs:{"bills":_vm.bills,"denomination":_vm.denomination,"series":_vm.series,"feature":_vm.feature},on:{"bill":_vm.billChanged,"feature":_vm.featureChanged}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c513b0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bills.vue
// module id = 599
// module chunks = 0